<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 4h1.5l1.6 9.6a2 2 0 0 0 2 1.65h7.3a2 2 0 0 0 1.97-1.62l1.13-6.13H6.1" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
<circle cx="9" cy="19.5" r="1.3" stroke="currentColor" stroke-width="1.6"/>
<circle cx="16" cy="19.5" r="1.3" stroke="currentColor" stroke-width="1.6"/>
</svg>
</template>
